import { OddsApiSports } from "./odds-api-sports";

export enum PlayerBetTypes {
    PlayerPoints = 'player_points',
    PlayerRebounds = 'player_rebounds',
    PlayerAssists = 'player_assists',
    PlayerThrees = 'player_threes',
    PlayerBlocks = 'player_blocks',
    PlayerSteals = 'player_steals',
    PlayerBlocksSteals = 'player_blocks_steals',
    PlayerTurnovers = 'player_turnovers',
    PlayerPointsReboundsAssists = 'player_points_rebounds_assists',
    PlayerPointsRebounds = 'player_points_rebounds',
    PlayerPointsAssists = 'player_points_assists',
    PlayerReboundsAssists = 'player_rebounds_assists',
    PlayerFirstBasket = 'player_first_basket',
    PlayerDoubleDouble = 'player_double_double',
    PlayerTripleDouble = 'player_triple_double'
}

export const supportedPlayerMarketsBySport: Map<OddsApiSports, PlayerBetTypes[]> = new Map([
    [
        OddsApiSports.BasketballNba, 
        [
            PlayerBetTypes.PlayerPoints,
            PlayerBetTypes.PlayerAssists,
            PlayerBetTypes.PlayerRebounds,
            PlayerBetTypes.PlayerPointsReboundsAssists,
            PlayerBetTypes.PlayerPointsRebounds,
            PlayerBetTypes.PlayerPointsAssists,
            PlayerBetTypes.PlayerThrees,
        ]
    ]
]);